import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Observable, Subscription, map } from 'rxjs';
import Swal from 'sweetalert2';

import { ProfileService } from '../../../../services/profile.service';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { UserService } from '../../../../services/user';
import { ItemsService } from '../../../../services/items.service';
import { OrdersService } from '../../../../services/orders';
import { FinancialManagerService } from '../../../../services/financial-manager';
import { DeliveryService } from '../../../../services/delivery';
import { WarehouseTypeService } from '../../../../services/warehouse-type';

import { Order } from '../../../../interfaces/order';
import { users } from '../../../../interfaces/users';

const ORDER_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  REJECTED: 3,
  ON_THE_WAY: 4,
  SHIPPED: 5,
  DEFERRED: 6,
  NOT_CONTACT_CLIENT: 7,
  DELIVERED: 8,
} as const;

const DELIVERY_STATUS = {
  WAITING: 0,
  IN_PROGRESS: 1,
  NOT_DELIVERED: 2,
  DELIVERED: 3,
} as const;

const PAYMENT_TYPE = {
  CASH: '0',
  VODAFONE_CASH: '1',
  INSTAPAY: '2',
  ONLINE_PAYMENT: '3',
  BANK_TRANSFER: '4',
  CREDIT: '5',
} as const;

const WAREHOUSE_TYPE = {
  COMPANY: 0,
  WAREHOUSE: 1,
  STORE: 2,
  CLINIC: 3,
  STORE_AND_CLINIC: 4,
} as const;

const ACCOUNT_TYPE = {
  ADMIN: '1',
  SUPER_ADMIN: '10',
  SUB_ADMIN: '6',
  DELIVERY_HERO: '8',
} as const;

@Component({
  selector: 'app-orderpagemobile',
  templateUrl: './orderpagemobile.component.html',
  styleUrl: './orderpagemobile.component.scss',
})
export class OrderpagemobileComponent implements OnInit, OnDestroy {
  @Input() isProfile: string = '';

  // UI state
  contentReady = true;
  isLoadingMore = false;
  noData = false;
  showPopUp = false;
  showRejectPopUp = false;
  showDiscountPopUp = false;
  showDeliveryHeroPopUp = false;
  showCommentPopUp = false;
  showPaymentPopUp = false;
  showtodaysorders = false;
  showQuickInvoice = false;
  showPartCompPopUp = false;
  showoptions = false;
  searched = false;
  changeRemaining = false;
  clear = false;
  readonly isAr: boolean = localStorage.getItem('language') === 'ar';

  // User / account
  userimage!: string;
  userData!: users;
  username!: string;
  userPhone = '';
  userName = '';
  userfirstname = '';
  userFacebook = '';
  userInstgram = '';
  userTiktok = '';
  accountType!: string;
  userId!: any;
  thisUserId!: number;
  warehouseId!: any;
  warehouse_id!: any;
  adminStatus!: string;
  isAdmin = false;
  isSubAdmin = false;
  isDeliveryHero = false;
  showAdminContent = false;

  // Warehouse type flags
  isCompany = false;
  isWarehouse = false;
  isStore = false;
  isClinic = false;
  isStoreAndClinic = false;

  // Orders data
  allData: any[] = [];
  selectedDeliveryOrders: any[] = [];
  todaysOrders: any[] = [];
  deliveryHeros: any[] = [];
  allWareHouses: any[] = [];
  stockTotal = 0;
  totalItems = 0; // last page
  page = 1;
  newPage = 1;
  searchKey = '';
  searchOrderId!: any | null;
  searchstatus!: number | null;
  searchtype!: string | null;
  todaysOrdersIds: any;

  // Action / popup data
  orderchange!: FormGroup;
  reason = '';
  commentOrderId!: any | null;
  DiscountOrderId!: number | null;
  deliveryHeroOrderId!: number | null;
  orderId!: number | null;
  payment_type!: any | null;
  payed!: any;
  not_payed!: any;
  comment!: string | null;
  discount!: string | null;
  total!: any | null;
  income!: string;
  duenow!: any;
  deliveryFees!: any;
  deliveryHero!: any;
  deliveryHeroId!: any | null;
  deliveryHeroInfo!: string | null;
  commentTotal: any;
  selectedOrderId!: number | null;
  selectedProductsDetails: any[] = [];

  isAdmin$: Observable<boolean>;
  isSubAdmin$: Observable<boolean>;
  private _accountTypeSub?: Subscription;
  private _userIdSub?: Subscription;

  constructor(
    private readonly router: Router,
    private readonly _profileService: ProfileService,
    private readonly _orderService: OrdersService,
    private readonly _userService: UserService,
    private readonly _itemsService: ItemsService,
    private readonly _financialManager: FinancialManagerService,
    private readonly excelExportService: ExcelExportService,
    private readonly _deliveryhero: DeliveryService,
    public warehouseTypeService: WarehouseTypeService,
  ) {
    this.isAdmin$ = this._userService.getAccountType().pipe(
      map(() => this.accountType === ACCOUNT_TYPE.ADMIN || this.accountType === ACCOUNT_TYPE.SUPER_ADMIN),
    );
    this.isSubAdmin$ = this._userService.getAccountType().pipe(
      map(() => this.accountType === ACCOUNT_TYPE.SUB_ADMIN),
    );
  }

  ngOnInit(): void {
    this._initializeSelectedDeliveryOrders();
    this._subscribeToAccountType();
    this._subscribeToUserId();
  }

  ngOnDestroy(): void {
    this._accountTypeSub?.unsubscribe();
    this._userIdSub?.unsubscribe();
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 180;

    if (bottomReached && this.hasMore()) {
      this.loadMore();
    }
  }

  // ==================== Init ====================
  private _subscribeToAccountType(): void {
    this._accountTypeSub = this._userService.getAccountType().subscribe({
      next: (data) => {
        this.warehouseId = Number(localStorage.getItem('posId')) || null;
        this.warehouse_id = this.warehouseId;
        this.accountType = data['user_type'];
        this._setAccountFlags();
        this._setWarehouseFlags();

        if (this.isProfile === 'true') {
          this.getUserOrders(1);
          return;
        }

        if (!this.isAdmin && !this.isSubAdmin && !this.isDeliveryHero) {
          this.getUserOrders(1);
          return;
        }

        if (this.isDeliveryHero) {
          this.getDeliveryHeroOrders(localStorage.getItem('username')!, 1);
          return;
        }

        if (this.warehouseId != null) {
          this._itemsService.getWearHouses().subscribe({
            next: (res) => (this.allWareHouses = res.warehouse || []),
            error: (err) => console.error(err),
          });
          this.getWarehouseOrdersData(this.warehouseId, 1);
        } else {
          this.noData = true;
          this.contentReady = false;
        }
      },
      error: (error) => console.error(error),
    });
  }

  private _subscribeToUserId(): void {
    this._userIdSub = this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = Number(data['user_id']);
        this.thisUserId = Number(data['user_id']);
      },
      error: (error) => console.error(error),
    });
  }

  private _initializeSelectedDeliveryOrders(): void {
    const stored = localStorage.getItem('selectedDeliveryOrders');
    this.selectedDeliveryOrders = stored ? JSON.parse(stored) : [];
  }

  private _setAccountFlags(): void {
    this.isAdmin = this.accountType === ACCOUNT_TYPE.ADMIN || this.accountType === ACCOUNT_TYPE.SUPER_ADMIN;
    this.isSubAdmin = this.accountType === ACCOUNT_TYPE.SUB_ADMIN;
    this.isDeliveryHero = this.accountType === ACCOUNT_TYPE.DELIVERY_HERO;
    this.showAdminContent = this.isAdmin || this.isSubAdmin;
  }

  private _setWarehouseFlags(): void {
    this.isCompany = false;
    this.isWarehouse = false;
    this.isStore = false;
    this.isClinic = false;
    this.isStoreAndClinic = false;

    if (!this.warehouseId) return;

    this._userService.getWarehouseType(this.warehouseId).subscribe({
      next: (data) => {
        const type = Number(data['warehouses_type']);
        switch (type) {
          case WAREHOUSE_TYPE.COMPANY:
            this.isCompany = true;
            break;
          case WAREHOUSE_TYPE.WAREHOUSE:
            this.isWarehouse = true;
            break;
          case WAREHOUSE_TYPE.STORE:
            this.isStore = true;
            break;
          case WAREHOUSE_TYPE.CLINIC:
            this.isClinic = true;
            break;
          case WAREHOUSE_TYPE.STORE_AND_CLINIC:
            this.isStoreAndClinic = true;
            break;
        }
      },
      error: (err) => console.error(err),
    });
  }

  get usesSimpleOrderStatusFilter(): boolean {
    return this.isStore || this.isClinic || this.isStoreAndClinic;
  }

  // ==================== Navigation ====================
  checkWarehouseType(): void {
    this._userService.getWarehouseType(Number(localStorage.getItem('posId'))).subscribe({
      next: ({ warehouses_type }) => {
        const type = Number(warehouses_type);
        if ([2, 3, 4].includes(type)) {
          this.router.navigate(['/Addorderstore']);
        } else if (type === 1) {
          this.router.navigate(['/Addorderwarehouse']);
        } else {
          this.router.navigate(['/Addorder']);
        }
      },
      error: (err) => console.error(err),
    });
  }

  details(orderId: number, website?: boolean): void {
    const posId = Number(localStorage.getItem('posId'));
    this._userService.getWarehouseType(posId).subscribe({
      next: ({ warehouses_type }) => {
        const type = Number(warehouses_type);

        if ([2, 3, 4].includes(type)) {
          this.router.navigate(['/storeinvoice'], { queryParams: { id: orderId } });
          return;
        }

        if (type === 1) {
          this.router.navigate(['/warehouseinvoice'], { queryParams: { id: orderId } });
          return;
        }

        this.router.navigate([website ? '/websiteinvoice' : '/petcompanyinvoice'], {
          queryParams: { id: orderId },
        });
      },
      error: (err) => console.error(err),
    });
  }

  accStatement(phone: string): void {
    this.router.navigate(['/accountstatement'], { queryParams: { phone } });
  }

  quickInvoice(orderId: number): void {
    this.selectedOrderId = orderId;
    this.showQuickInvoice = true;
  }

  // ==================== Load data ====================
  getUserOrders(page: number, append = false): void {
    this._startLoading(append);
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.userId = Number(data['user_id']);
        this._orderService.getOrderByUserId(this.userId, page).subscribe({
          next: (res) => this._handleListApiResponse(res, append, page),
          error: (error) => this._handleApiError(error),
        });
      },
      error: (error) => this._handleApiError(error),
    });
  }

  getDeliveryHeroOrders(id: string, page: number, append = false): void {
    this._startLoading(append);
    this._orderService.getDeliveryHeroesOrders(id, page).subscribe({
      next: (res) => this._handleListApiResponse(res, append, page),
      error: (error) => this._handleApiError(error),
    });
  }

  getWarehouseOrdersData(id: number, page: number, append = false): void {
    this.warehouseId = id;
    this.warehouse_id = id;
    this._startLoading(append);
    this._orderService.getOrdersByWarehouseId(id, page).subscribe({
      next: (res) => this._handleListApiResponse(res, append, page),
      error: (error) => this._handleApiError(error),
    });
  }

  getOrdersData(perpage: number, page: number, append = false): void {
    this._startLoading(append);
    this._orderService.getOrders(perpage, page).subscribe({
      next: (res) => this._handleListApiResponse(res, append, page),
      error: (error) => this._handleApiError(error),
    });
  }

  loadMore(): void {
    if (!this.hasMore()) return;

    if (this.searchstatus != null) {
      this.filterbystatus(this.searchstatus, this.searchtype || 'order_status', this.page, true);
      return;
    }

    if (this.isDeliveryHero) {
      this.getDeliveryHeroOrders(localStorage.getItem('username')!, this.page, true);
      return;
    }

    if (this.isAdmin || this.isSubAdmin) {
      if (this.warehouseId) this.getWarehouseOrdersData(this.warehouseId, this.page, true);
      return;
    }

    this.getUserOrders(this.page, true);
  }

  hasMore(): boolean {
    return !this.searched && !this.contentReady && !this.isLoadingMore && !this.noData && this.page <= this.totalItems;
  }

  // ==================== Search / filters ====================
  search(): void {
    if (!this.searchKey || this.searchKey.trim() === '') return;
    this.searched = true;
    this.resetPagination();
    this.contentReady = true;
    this._orderService
      .searchOrders(this.searchKey, this.warehouseId, !this.isAdmin && !this.isSubAdmin ? this.userId : null)
      .subscribe({
        next: (data) => {
          this.allData = Array.isArray(data) ? data : data?.data || [];
          this.stockTotal = this.allData.length;
          this.totalItems = 1;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => this._handleApiError(error),
      });
  }

  searchOrderbyId(): void {
    if (!this.searchOrderId) return;
    this.searched = true;
    this.resetPagination();
    this.contentReady = true;
    this._orderService.getOrderByWarehouse(this.warehouseId, this.searchOrderId).subscribe({
      next: (data) => {
        this.allData = data ? [data] : [];
        this.stockTotal = this.allData.length;
        this.totalItems = 1;
        this.noData = this.allData.length === 0;
        this.contentReady = false;
      },
      error: () => {
        this.allData = [];
        this.noData = true;
        this.contentReady = false;
      },
    });
  }

  clearSearch(): void {
    this.searchKey = '';
    this.searchOrderId = null;
    this.searchstatus = null;
    this.searchtype = null;
    this.todaysOrdersIds = null;
    this.searched = false;
    this.resetPagination();
    this._refreshOrdersData();
  }

  advancedSearch(): void {
    this.showoptions = true;
  }

  clearFilters(): void {
    this.showoptions = false;
    this.clearSearch();
  }

  applyStatusFilter(id: number, statusType: string): void {
    this.searched = false;
    this.resetPagination();
    this.filterbystatus(id, statusType, 1);
  }

  filterbystatus(status: number, type: string, page: number, append = false): void {
    if (!this.warehouseId) return;
    this.searchstatus = status;
    this.searchtype = type;
    this.newPage = page;
    this._startLoading(append);
    this._orderService.filterOrders(this.warehouseId, type, status, page, 10).subscribe({
      next: (data) => this._handleListApiResponse(data, append, page),
      error: (error) => this._handleApiError(error),
    });
  }

  applyWareHouse(warehouseId: number): void {
    this.warehouseId = warehouseId;
    this.warehouse_id = warehouseId;
    this.resetPagination();
    this._setWarehouseFlags();
    this.getWarehouseOrdersData(warehouseId, 1);
  }

  getTodyasOrders(): void {
    this.showtodaysorders = true;
    this.contentReady = true;
    this._orderService.getTodayOrders().subscribe({
      next: (data) => {
        this.todaysOrders = data || [];
        this.contentReady = false;
      },
      error: (error) => this._handleApiError(error),
    });
  }

  getTodaysOrders(ids: any): void {
    this.todaysOrdersIds = ids;
    this.showtodaysorders = false;
    this.contentReady = true;
    this._orderService.getOrdersByIds(ids).subscribe({
      next: (data) => {
        this.allData = data || [];
        this.stockTotal = this.allData.length;
        this.totalItems = 1;
        this.noData = this.allData.length === 0;
        this.contentReady = false;
      },
      error: (error) => this._handleApiError(error),
    });
  }

  resetPagination(): void {
    this.page = 1;
    this.newPage = 1;
  }

  // ==================== Order actions ====================
  deleteOrder(id: string, orderstatus: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no',
    }).then((result) => {
      if (!result.isConfirmed) return;

      if (orderstatus != '2') {
        this.contentReady = true;
        this._orderService.updateQty('3', id).subscribe({
          next: () => {
            this._orderService.deleteOrder(id).subscribe({
              next: () => this._refreshOrdersData(),
              error: (err) => console.error(err),
            });
          },
          error: (err) => console.error(err),
        });
        return;
      }

      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'للاسف' : 'sorry',
        text: this.isAr ? 'لازم تبقي ادمن' : 'can`t delete this order contact the admin',
      });
    });
  }

  changeorderstatus(orderId: number, status: string, reason?: string, total?: number): void {
    this.adminStatus = status;
    this.commentOrderId = orderId;
    this.commentTotal = total;
    Swal.fire({
      title: this.isAr ? 'عايز تسيب تعليق' : 'add comment?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'no',
    }).then((result) => {
      if (result.isConfirmed) {
        this.showCommentPopUp = true;
      } else {
        this._executeOrderStatusChange(orderId, status, reason, total);
      }
    });
  }

  updateComment(): void {
    if (!this.commentOrderId) return;
    this.contentReady = true;
    this._orderService.addCommentInOrder(this.commentOrderId, this.comment || '').subscribe({
      next: () => {
        this._executeOrderStatusChange(this.commentOrderId, this.adminStatus, '', this.commentTotal);
        this.showCommentPopUp = false;
        this.comment = '';
      },
      error: (err) => console.error(err),
    });
  }

  rejectorder(orderId: number): void {
    this.orderId = orderId;
    this.showRejectPopUp = true;
  }

  onSubmit(): void {
    if (this.orderId) this._executeOrderStatusChange(this.orderId, '3', this.reason);
    this.close();
  }

  showDiscount(orderId: number, total: number): void {
    Swal.fire({
      title: this.isAr ? 'عايز تعمل خصم علي الفاتورة' : 'add Discount?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'yes',
      cancelButtonText: this.isAr ? 'لا' : 'no',
    }).then((result) => {
      if (result.isConfirmed) {
        this.DiscountOrderId = orderId;
        this.total = total;
        this.showDiscountPopUp = true;
      }
    });
  }

  addDiscount(): void {
    if (!this.DiscountOrderId || this.total == null || this.discount == null) return;
    this.contentReady = true;
    const newTotal = parseInt(String(this.total), 10) - parseInt(this.discount, 10);
    this._orderService.adddiscountOrTotalOrIcome(this.DiscountOrderId, String(newTotal), this.income, this.discount).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تمام' : 'success',
          text: this.isAr ? 'تم اضافة خصم' : 'discount added',
        });
        this.DiscountOrderId = null;
        this.showDiscountPopUp = false;
        this.contentReady = false;
        this._refreshOrdersData();
      },
      error: (err) => this._handleApiError(err),
    });
  }

  getAllHeros(warehouseId: number, hasPagination: boolean): void {
    this._deliveryhero.getAllDeliveryStars(warehouseId, hasPagination).subscribe({
      next: (data) => (this.deliveryHeros = data || []),
      error: (error) => console.error(error),
    });
  }

  addDeliveryHero(orderId: number): void {
    if (!this.warehouseId) return;
    this.getAllHeros(this.warehouseId, false);
    this.deliveryHeroOrderId = orderId;
    this.showDeliveryHeroPopUp = true;
  }

  onDeliveryHeroChange(): void {
    if (this.deliveryHero) {
      this.deliveryHeroId = this.deliveryHero.phone;
      this.deliveryHeroInfo = `${this.deliveryHero.name} ${this.deliveryHero.phone}`;
    } else {
      this.deliveryHeroId = null;
      this.deliveryHeroInfo = null;
    }
  }

  addHero(): void {
    if (!this.deliveryHeroOrderId) return;
    this.contentReady = true;
    this._orderService.addDeliveryHero(this.deliveryHeroOrderId, this.deliveryHeroInfo).subscribe({
      next: () => {
        this.contentReady = false;
        this.showDeliveryHeroPopUp = false;
        this._addHeroId();
      },
      error: (err) => this._handleApiError(err),
    });
  }

  changeDeliveryStatus(orderId: number, status: number, warehouseId: any, total?: number): void {
    this.contentReady = true;
    this._orderService.updateDeliveryStatus(orderId, status).subscribe({
      next: () => {
        this.getDeliveryHeroOrders(localStorage.getItem('username')!, 1);
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تمام' : 'success',
          text: this.isAr ? 'تم تحديث حالة التوصيل' : 'Delivery status updated',
        });
        if (status === DELIVERY_STATUS.DELIVERED) {
          this.sendToFinancialManager(orderId, localStorage.getItem('username'), localStorage.getItem('username'), total, warehouseId);
        }
        this.contentReady = false;
      },
      error: (err) => this._handleApiError(err),
    });
  }

  addToDeliveryOrders(order: any): void {
    if (!this.selectedDeliveryOrders) this.selectedDeliveryOrders = [];

    const exists = this.selectedDeliveryOrders.some((o) => o.id === order.id);
    if (exists) {
      Swal.fire({
        icon: 'error',
        title: this.isAr ? 'اضاف قبل كده' : 'Order already exists',
        confirmButtonText: this.isAr ? 'تمام' : 'ok',
      });
      return;
    }

    this.selectedDeliveryOrders.push(order);
    localStorage.setItem('selectedDeliveryOrders', JSON.stringify(this.selectedDeliveryOrders));
  }

  requestYourCommission(orderId: number): void {
    this._orderService.paymentRequest(orderId).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تمام' : 'success',
          text: this.isAr ? 'تم طلب عمولتك' : 'your Commission request added',
        });
        this._refreshOrdersData();
      },
      error: (err) => console.error(err),
    });
  }

  showPopUpPartiallyCompleted(orderObj: any): void {
    this.showPartCompPopUp = true;
    this.orderId = orderObj.id;
    this.total = orderObj.total;
    this.duenow = 'مكتمل جزئيا';
    this.deliveryFees = orderObj.delivery_fees;
    this.income = orderObj.income;

    const items = this.tolist(orderObj.item);
    const productIds = this.tolist(orderObj.product_id);
    const quantities = this.tolist(orderObj.quantity);
    const prices = this.tolist(orderObj.price);
    const itemPrices = this.tolist(orderObj.itemsprices);
    const bonuses = this.tolist(orderObj.bonuses);

    this.selectedProductsDetails = items.map((item: string, i: number) => ({
      product_id: productIds[i],
      item: item.trim(),
      price: Number(prices[i] || 0),
      bounes: Number(bonuses[i] || 0),
      quantity: Number(quantities[i] || 1),
      itemPrice: Number(itemPrices[i] || prices[i] || 0),
    }));
  }

  partialComplated(): void {
    if (!this.orderId) return;
    this.contentReady = true;

    let totalSum = 0;
    let totalSumRealPricesNumber = 0;
    this.selectedProductsDetails.forEach((item: any) => {
      totalSumRealPricesNumber += Number(item.itemPrice) * Number(item.quantity);
      totalSum += Number(item.price) * Number(item.quantity);
    });

    const updatedQuantities = this.selectedProductsDetails.map((item: any) => Number(item.quantity));
    const updatedBonuses = this.selectedProductsDetails.map((item: any) => Number(item.bounes));
    this.total = totalSum + parseInt(String(this.deliveryFees || 0), 10);
    this.duenow = this.total - totalSumRealPricesNumber - parseInt(String(this.deliveryFees || 0), 10);

    this._orderService
      .updateQuantityIncomeTotal(this.orderId, updatedQuantities, updatedBonuses, String(this.duenow), String(this.total))
      .subscribe({
        next: () => {
          Swal.fire({
            icon: 'success',
            title: this.isAr ? 'تمام' : 'success',
            text: this.isAr ? 'تم تعديل الفاتورة' : 'invoice updated',
          });
          if (!this.isWarehouse) this.showPaymentPopUp = true;
          this.showPartCompPopUp = false;
          this.contentReady = false;
          this._refreshOrdersData();
        },
        error: (err) => this._handleApiError(err),
      });
  }

  addremaining(paid: any, remaining: any, id: number): void {
    this.orderId = id;
    this.payed = paid;
    this.not_payed = remaining;
    this.changeRemaining = true;
    this.showPaymentPopUp = true;
  }

  changePaymentType(): void {
    if (!this.orderId) return;
    this.contentReady = true;

    const apiCall = this.changeRemaining
      ? this._orderService.updatePaymentType(this.orderId, undefined, this.payed, this.not_payed)
      : this._orderService.updatePaymentType(
          this.orderId,
          this.payment_type,
          this.payment_type === PAYMENT_TYPE.CREDIT ? this.payed : undefined,
          this.payment_type === PAYMENT_TYPE.CREDIT ? this.not_payed : undefined,
        );

    apiCall.subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تمام' : 'Success',
          text: this.isAr
            ? this.changeRemaining
              ? 'تم تعديل المبلغ'
              : 'تم تعديل الدفع'
            : this.changeRemaining
              ? 'Amount updated'
              : 'Payment updated',
        });
        const revAmount = this.changeRemaining || this.payment_type === PAYMENT_TYPE.CREDIT ? this.payed : this.total;
        this.addRev(revAmount, this.orderId, this.payment_type);
        this.showPaymentPopUp = false;
        this.payment_type = null;
        this.changeRemaining = false;
        this.contentReady = false;
        this._refreshOrdersData();
      },
      error: () => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'خطأ' : 'Error',
          text: this.isAr ? 'فشل في تعديل الدفع' : 'Failed to update payment',
        });
        this.contentReady = false;
      },
    });
  }

  updateQuantity(status: string, orderId: string): void {
    this._orderService.updateQty(status, orderId).subscribe({
      next: (res) => console.log(res),
      error: (err) => console.error(err),
    });
  }

  sendToFinancialManager(orderId: any, subDeliveryId: any, deliveryHeroId: any, amountCollected: any, warehouseId: any): void {
    const formData = new FormData();
    formData.append('order_id', String(orderId));
    formData.append('sub_dilivery_id', String(subDeliveryId));
    formData.append('deliveryhero_id', String(deliveryHeroId));
    formData.append('amount_collected', String(amountCollected));
    formData.append('warehouse_id', String(warehouseId));

    this._deliveryhero.createDeliveryCollection(formData).subscribe({
      next: () => {},
      error: (err) => console.error(err),
    });
  }

  addRev(total: any, orderid: any, type?: string): void {
    const bonusPayload = {
      warehouse_id: localStorage.getItem('posId'),
      employee_id: this.userId || this.thisUserId,
      username: localStorage.getItem('username'),
      amount: total,
      amount_type: type ?? '0',
      note: String(orderid),
      type: '3',
    };

    this._financialManager.addRevenue(bonusPayload).subscribe({
      next: () => {},
      error: (error) => console.error(error),
    });
  }

  getUserItems(id: string): void {
    this.contentReady = true;
    this._profileService.getuserinfo(id).subscribe({
      next: (res) => {
        this.userData = res;
        this.showPopUp = true;
        this.userName = this.userData.username;
        this.userfirstname = this.userData.first_name;
        this.userFacebook = this.userData.facebook_link;
        this.userInstgram = this.userData.instagram_link;
        this.userTiktok = this.userData.tiktok_link;
        this.userPhone = this.userData.phone;
        this.userimage = 'https://backendproduction.blueboxpet.com/' + this.userData.image;
        this.contentReady = false;
      },
      error: (err) => this._handleApiError(err),
    });
  }

  exportToExcel(): void {
    this.excelExportService.exportToExcel('orderstable', 'Orders', ['actions']);
  }

  close(): void {
    this.showQuickInvoice = false;
    this.showPopUp = false;
    this.showRejectPopUp = false;
    this.showCommentPopUp = false;
    this.showDiscountPopUp = false;
    this.showDeliveryHeroPopUp = false;
    this.showPartCompPopUp = false;
    this.showPaymentPopUp = false;
    this.showtodaysorders = false;
  }

  // ==================== Template helpers ====================
  isNaN(total: any): boolean {
    return Number.isNaN(Number(total));
  }

  getInitial(name: any): string {
    return String(name || '?').trim().charAt(0).toUpperCase();
  }

  getOrderStatusClass(element: any): string {
    if (element?.ispartially_completed) return 'partial';

    switch (Number(element?.order_status)) {
      case ORDER_STATUS.PENDING:
        return 'pending';
      case ORDER_STATUS.APPROVED:
        return 'approved';
      case ORDER_STATUS.REJECTED:
        return 'rejected';
      case ORDER_STATUS.ON_THE_WAY:
        return 'ontheway';
      case ORDER_STATUS.SHIPPED:
        return 'shipped';
      case ORDER_STATUS.DEFERRED:
        return 'deferred';
      case ORDER_STATUS.NOT_CONTACT_CLIENT:
        return 'notcontact';
      case ORDER_STATUS.DELIVERED:
        return 'delivered';
      default:
        return 'pending';
    }
  }

  getDeliveryStatusClass(status: any): string {
    switch (Number(status)) {
      case DELIVERY_STATUS.WAITING:
        return 'waiting';
      case DELIVERY_STATUS.IN_PROGRESS:
        return 'inprogress';
      case DELIVERY_STATUS.NOT_DELIVERED:
        return 'notdelivered';
      case DELIVERY_STATUS.DELIVERED:
        return 'delivered';
      default:
        return 'waiting';
    }
  }


  trackById(index: number, item: any): any {
    return item?.id ?? index;
  }

  tolist(list: any): string[] {
    if (list === null || list === undefined) return [];

    if (Array.isArray(list)) {
      if (list.length === 1 && typeof list[0] === 'string') {
        return list[0]
          .split(',')
          .map((item: string) => item.trim())
          .filter((item: string) => item !== '');
      }

      return list
        .flatMap((item: any) => String(item).split(','))
        .map((item: string) => item.trim())
        .filter((item: string) => item !== '');
    }

    return String(list)
      .split(',')
      .map((item: string) => item.trim())
      .filter((item: string) => item !== '');
  }

  // ==================== Private helpers ====================
  private _startLoading(append: boolean): void {
    if (append) {
      this.isLoadingMore = true;
    } else {
      this.contentReady = true;
    }
  }

  private _handleListApiResponse(data: any, append: boolean, loadedPage: number): void {
    const list = Array.isArray(data) ? data : data?.data || [];
    this.allData = append ? [...this.allData, ...list] : list;
    this.stockTotal = Array.isArray(data) ? this.allData.length : data?.total || this.allData.length;
    this.totalItems = Array.isArray(data) ? 1 : data?.last_page || 1;
    this.page = loadedPage + 1;
    this.newPage = loadedPage;
    this.noData = this.allData.length === 0;
    this.contentReady = false;
    this.isLoadingMore = false;
  }

  private _handleApiError(error: any): void {
    console.error(error);
    this.contentReady = false;
    this.isLoadingMore = false;
  }

  private _refreshOrdersData(): void {
    this.resetPagination();

    if (this.searchstatus != null) {
      this.filterbystatus(this.searchstatus, this.searchtype || 'order_status', 1);
      return;
    }

    if (this.isDeliveryHero) {
      this.getDeliveryHeroOrders(localStorage.getItem('username')!, 1);
      return;
    }

    if (this.todaysOrdersIds != null) {
      this.getTodaysOrders(this.todaysOrdersIds);
      return;
    }

    if (this.isAdmin || this.isSubAdmin) {
      if (this.warehouseId) this.getWarehouseOrdersData(this.warehouseId, 1);
      return;
    }

    this.getUserOrders(1);
  }

  private _executeOrderStatusChange(orderId: number, status: string, reason?: string, total?: number): void {
    if (!orderId) return;
    this.contentReady = true;
    this.total = total;
    this.orderId = orderId;

    this._orderService.changeStatus(orderId, status, reason).subscribe({
      next: () => {
        if (status === '3') this.updateQuantity(status, String(orderId));
        if (status === '5' && !this.isWarehouse) this.showPaymentPopUp = true;
        this.reason = '';
        this._refreshOrdersData();
      },
      error: (err) => this._handleApiError(err),
    });
  }

  private _addHeroId(): void {
    if (!this.deliveryHeroOrderId || !this.deliveryHeroId) return;
    this._orderService.updateDeliveryHero(this.deliveryHeroOrderId, this.deliveryHeroId).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تمام' : 'success',
          text: this.isAr ? 'تم اضافة مندوب شحن' : 'delivery Hero added',
        });
        this.deliveryHeroOrderId = null;
        this.deliveryHeroId = null;
        this.deliveryHeroInfo = null;
        this._refreshOrdersData();
      },
      error: (err) => this._handleApiError(err),
    });
  }
}
